import { SUBPAGES, TSubPage, TSubPages } from './types';

const initialSubPage: TSubPage = {
  isDirty: false,
};

const initialState: TSubPages = {
  [SUBPAGES.LOAN_DETAILS]: initialSubPage,
  [SUBPAGES.PROPERTY]: initialSubPage,
  [SUBPAGES.REPAYMENT_STRATEGY]: initialSubPage,
  [SUBPAGES.ADMIN]: initialSubPage,
  [SUBPAGES.LIFE_ASSURANCE]: initialSubPage,
  [SUBPAGES.APPLICANTS]: [
    {
      [SUBPAGES.APPLICANT_PERSONAL_DETAILS]: initialSubPage,
      [SUBPAGES.APPLICANT_VULNERABILITY]: initialSubPage,
      [SUBPAGES.APPLICANT_EMPLOYMENT]: initialSubPage,
      [SUBPAGES.APPLICANT_ASSETS]: initialSubPage,
      [SUBPAGES.APPLICANT_INCOME_CURRENT]: initialSubPage,
      [SUBPAGES.APPLICANT_INCOME_FUTURE]: initialSubPage,
      [SUBPAGES.APPLICANT_PENSIONS_CURRENT]: initialSubPage,
      [SUBPAGES.APPLICANT_PENSIONS_FUTURE]: initialSubPage,
      [SUBPAGES.APPLICANT_EXPENDITURES]: initialSubPage,
    },
    {
      [SUBPAGES.APPLICANT_PERSONAL_DETAILS]: initialSubPage,
      [SUBPAGES.APPLICANT_VULNERABILITY]: initialSubPage,
      [SUBPAGES.APPLICANT_EMPLOYMENT]: initialSubPage,
      [SUBPAGES.APPLICANT_ASSETS]: initialSubPage,
      [SUBPAGES.APPLICANT_INCOME_CURRENT]: initialSubPage,
      [SUBPAGES.APPLICANT_INCOME_FUTURE]: initialSubPage,
      [SUBPAGES.APPLICANT_PENSIONS_CURRENT]: initialSubPage,
      [SUBPAGES.APPLICANT_PENSIONS_FUTURE]: initialSubPage,
      [SUBPAGES.APPLICANT_EXPENDITURES]: initialSubPage,
    },
  ],
  [SUBPAGES.RATIONALE]: initialSubPage,
};

const exportObject = {
  initialState,
};

export default exportObject;
